import { TrackPageModel } from './model';
import { action, runInAction } from 'mobx';
import { RedirectFunction, RouterState } from 'react-router';
import { BugsnagController } from '../../bugsnag/controller';
import { EnvModel } from '../../env/model';
import { UIController } from '../../ui/controller';
import { APIController } from '../../api/controller';
import { ContentModel } from '../../content/model';
import { ImageController } from '../../image/controller';
import {stripQueryString} from '../../../lib/string';

export class TrackPageController {
  constructor(
    private model: TrackPageModel,
    private bugsnag: BugsnagController,
    private env: EnvModel,
    private api: APIController,
    private ui: UIController,
    private content: ContentModel,
    private image: ImageController,
  ) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    runInAction(() => {
      this.model.artistSlug = stripQueryString(nextState.params['artist']);
      this.model.trackSlug = stripQueryString(nextState.params['track']);
      this.model.loading = true;
    });

    try {
      const [resp] = await Promise.all([
        this.api.artist.getTrack(this.model.artistSlug, this.model.trackSlug),
        this.env.ready
      ]);

      const track = resp.data;
      const artists = track.artists;
      const artist = artists[0];

      runInAction(() => {
        const breadcrumbs = [
          {
            path: '/browse/artists',
            label: 'Artists'
          },
          {
            path: '/browse/artists/a',
            label: this.model.artistSlug[0].toUpperCase()
          },
          {
            path: '/music/artists/' + this.model.artistSlug,
            label: artist.name,
          },
          {
            path: '/music/artists/' + this.model.artistSlug + '/track/' + this.model.trackSlug,
            label: track.title
          }
        ];

        this.ui.setBreadcrumbs(breadcrumbs);
      });

      await this.ui.setSEO('/music/artists/track', {
        track: track.title,
        artist: artist.name,
      });

      this.ui.setOpenGraph({
        image: this.image.preloadImage(track.images.identity, { width: 1200, height: 0 })
      });

      const { genres } = this.content;

      runInAction(() => {
        this.model.track = track;
        this.model.artists = artists;
        this.model.artist = artist;
        this.model.pageBody = this.content.strapTrack;
        this.model.genres = track.tags && track.tags.hookd_genre && track.tags.hookd_genre.length !== 0
          ? track.tags.hookd_genre
            .filter(genre => genres.find(({ slug }) => genre.slug === slug))
            .map(genre => ({ slug: genre.slug, label: genre.name }))
          : [];

        this.ui.preloadPlayer(this.model.track);
      });
    } catch (e) {
      this.bugsnag.notifyException(e);
    } finally {
      runInAction(() => {
        this.model.loading = false;
      })
    }

    return;
  };
}